var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H25C25.2652 4 25.5196 4.10536 25.7071 4.29289C25.8946 4.48043 26 4.73478 26 5V9C25.9999 9.22855 25.9216 9.45019 25.778 9.628L18.728 18.354V27C18.7282 27.161 18.6894 27.3197 18.6151 27.4626C18.5408 27.6054 18.4331 27.7282 18.3011 27.8205C18.1692 27.9128 18.0169 27.9718 17.8572 27.9926C17.6975 28.0135 17.5352 27.9954 17.384 27.94L11.928 25.94C11.7355 25.8695 11.5693 25.7415 11.4519 25.5733C11.3346 25.4052 11.2718 25.205 11.272 25V18.354L4.222 9.628C4.07841 9.45019 4.00006 9.22855 4 9V5ZM28 19V21H20V19H28ZM26 25H20V23H26V25Z",
    fill: "#091540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellingsIcon);
export default __webpack_public_path__ + "static/media/sellings-icon.ddb958dc6fe386271f5180e2b491c8f4.svg";
export { ForwardRef as ReactComponent };